import React from 'react'
import { I18n } from 'react-redux-i18n';
import WidgetConfigField from "./WidgetConfigField";
import { config } from "../../config";
import PropTypes from "prop-types";

const WidgetForm =
    ({
         widgetType,
         backClicked,
         submitClicked,
         handleFieldChange,
         handleOnFieldBlur,
         formData,
         onEditMode,
         widgetToEdit
     }) => {
        return (
            <div className="widget-form">
                <div className="title-area"> {/*Title Area*/}
                    <span className="title">{I18n.t('dashboard.widgets.configurations.detailsFormTitle')}</span>
                    <span className="sub-title">{' - ' + I18n.t("dashboard.widgets.types." + widgetType)}</span>
                </div>
                <div className="fields-area"> {/*Fields*/}
                    {config.widgetsConfigs[widgetType].map((configRow, index) => (
                        <div key={"config-row-div-" + index}>
                            {configRow.configTypes.map(configType => (
                                <WidgetConfigField
                                    key={"config-row-" + index + "-" + configType.name}
                                    fieldConfig={configType}
                                    handleFieldChange={handleFieldChange}
                                    handleOnFieldBlur={handleOnFieldBlur}
                                    formData={formData}
                                />
                            ))}
                        </div>
                    ))}
                </div>
                <div className="buttons-area"> {/*Buttons*/}
                    {
                        !onEditMode &&
                        <button
                            className="mx-2 mt-3 btn btn-primary"
                            onClick={backClicked}
                        >
                            {I18n.t("forms.back")}
                        </button>
                    }
                    <button
                        className="mx-2 mt-3 btn btn-primary"
                        onClick={submitClicked}
                    >
                        {I18n.t("forms.save")}
                    </button>
                </div>
            </div>
        );
    };

WidgetForm.propTypes = {
    widgetType: PropTypes.string,
    submitClicked: PropTypes.func,
    backClicked: PropTypes.func,
    handleOnFieldBlur: PropTypes.func,
    handleFieldChange: PropTypes.func,
    formData: PropTypes.object,
    onEditMode: PropTypes.bool,
    widgetToEdit: PropTypes.object
};

export default WidgetForm;